/* eslint-disable @typescript-eslint/ban-ts-ignore */
import axios from 'axios'
import dateTimeFormater from '../dateTimeFormater'

const sendWebcastDataEdit = (data) => {

  const transformedData = {
    id: data.id,
    channel: { id: data.channel.id },
    title: typeof data.title === 'undefined' ? undefined : data.title.trim(),
    provider: data.provider,
    links: data.featureImage === 'deleted' ? [{ href: 'deleted', rel: 'related', type: 'image/png', title: 'preview' }, { href: 'deleted', rel: 'related', type: 'image/png', title: 'thumbnail' }] : data.links,
    showChannelSurvey: data.showChannelSurvey || false,
    clientBookingReference: typeof data.clientBookingReference === 'undefined' ? undefined : data.clientBookingReference.trim(),
    description: typeof data.description === 'undefined' ? undefined : data.description.trim(),
    keywords: data.keywords,
    format: (data.provider && data.provider.name === 'brighttalk' && data.format) ? data.format : 'video',
    presenter: typeof data.presenter === 'undefined' ? undefined : data.presenter.trim(),
    categories: data.categorisationTags,
    status: data.status,
    allowAnonymous: typeof data.allowAnonymous === 'undefined' ? undefined : data.allowAnonymous,
    customUrl: data.customUrl,
    autoTranscriptions:  data.autoCaptions === 'true' ? { enabled: 'true', language: data.autoCaptionsLanguage || 'en-US' }
    : { enabled: 'false' }
  }

  if(data.provider && data.provider.name !== 'brighttalk') {
    transformedData['serviced'] = data.serviced ? 'true' : 'false'
  }

  if (data.status !== 'live') {

    // @ts-ignore
    transformedData.visibility = data.visibility

  }

  if (!data.status || data.status === 'upcoming') {

    if (data.provider !== 'video') {
    // @ts-ignore
    transformedData.timeZone = data.timeZone
    
    }
    // @ts-ignore
    transformedData.scheduled = dateTimeFormater(data.startDate, data.startTime, data.timeZone)
    // @ts-ignore
    transformedData.duration = (data.provider && data.provider.name === 'replay') ? data.duration : data.duration * 60

  }

  if (data.provider && data.provider.name === 'video') {

    // @ts-ignore
    transformedData.scheduled = dateTimeFormater(data.startDate, data.startTime, data.timeZone)

  }

  if (data.status === 'recorded') {

    // @ts-ignore
    transformedData.publishStatus = data.publishStatus

  }

  if(data.unpublishDate && data.unpublishTime && data.publishStatus !== 'unpublished') {

    transformedData['unpublicationDate'] = dateTimeFormater(data.unpublishDate, data.unpublishTime, data.timeZone)

  }

  if (data?.status === 'processing') {
    delete transformedData?.status
  }

  return axios.put(`/service/communication/v1/channel/${data.channel.id}/communication/${data.id}`,
    transformedData,
    {
      headers: {
        'content-type': 'application/json',
        'accept': 'application/json'
      }
    }
  )

}

export default sendWebcastDataEdit
